import { BaseEntity, DefaultResponseWithData } from "./system";

export enum DismantlingBayType {
  Bay = 0,
  ProductionLine = 1,
}

export interface IDismantlingBay extends BaseEntity {
  name: string;
  capacity: number;
  easy: number;
  medium: number;
  hard: number;
  type: DismantlingBayType;
}

export interface ICreateUpdateDismantlingBayRequest {
  id?: string;
  name: string;
  capacity: number;
  easy: number;
  medium: number;
  hard: number;
  type: DismantlingBayType;
}

export interface IDismantlingBaysResponse extends DefaultResponseWithData<IDismantlingBay[]> {}
export interface ISingleDismantlingBayResponse extends DefaultResponseWithData<IDismantlingBay> {}

export interface IDismantlingBaySetting {
  dismantlingBayId: string;
  date: string;
  capacity: number;
  easy: number;
  medium: number;
  hard: number;
  isOverride: boolean;
}

export interface IUpsertDismantlingBaySettingRequest {
  capacity: number;
  easy: number;
  medium: number;
  hard: number;
}

export interface IDismantlingBaySettingResponse
  extends DefaultResponseWithData<IDismantlingBaySetting> {}

export interface IDismantlingBaySettingsResponse
  extends DefaultResponseWithData<IDismantlingBaySetting[]> {}
